import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { ScheduleService } from '../../services/schedule.service';
import { take, finalize } from 'rxjs/operators';

import { ClipboardService } from 'common-lib/services';
import { IAllNamedTypes } from '@app/core/interfaces';
import { MixpanelService } from '@app/core/services';
import { UserService } from '../../services/user.service';

declare var $: any;
@Component({
    selector: 'app-share',
    templateUrl: './share.component.html',
    styleUrls: ['./share.component.scss']
})
export class ShareComponent implements OnInit {
    @ViewChild('meetingTypeDropdown') meetingTypeDropdown: ElementRef;
    public meetingTypeNames: { name: string; value: string; selected: boolean }[] = [];
    public meetingTypes?: { [path in string]: IAllNamedTypes & { videoProviderObj: { id: string; type: string } } };

    public meetingType = {
        ondemand: {
            value: ''
        }
    };
    public selected = 'meeting';
    public daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    public fetchingTimes: { meetingType?: string } = {};
    public addTimesHTML = '';

    constructor(
        private scheduleService: ScheduleService,
        private mixpanelService: MixpanelService,
        private userService: UserService,
        @Inject(ClipboardService) private clipboardService: ClipboardService
    ) {}

    ngOnInit(): void {
        this.getMeetingTypesForDropdown();
    }

    private initDropdown() {
        $(this.meetingTypeDropdown.nativeElement).dropdown({
            values: this.meetingTypeNames,
            onChange: (value) => {
                if (value && value !== this.selected) {
                    this.updateMeetingType(value);
                }
            }
        });
    }

    private getMeetingTypesForDropdown() {
        this.scheduleService
            .getMeetingTypes()
            .pipe(take(1))
            .subscribe((response) => {
                this.meetingTypes = response.meetingTypes;
                this.meetingTypeNames = response.meetingTypeArray.map((type) => {
                    return {
                        name: type.name?.value,
                        value: type.name?.value,
                        selected: type.name?.value === 'meeting'
                    };
                });
                this.initDropdown();
            });
    }

    private updateMeetingType(type: string) {
        this.selected = type;
    }

    public copyText(text: string, copyHTMLFormatting = false) {
        this.clipboardService.copyText(text, copyHTMLFormatting);

        this.mixpanelService.trackPlatformEvent('psl', 'copy', 'outlook', undefined, this.userService.user);
    }

    public handleGetSuggestedTimes(type: string) {
        this.fetchingTimes.meetingType = type;

        this.scheduleService
            .getSuggestedTimes(type)
            .pipe(finalize(() => (this.fetchingTimes.meetingType = undefined)))
            .subscribe((res) => {
                this.addTimesHTML = res;
                this.showAddTimesModal(res);
            });
    }

    private showAddTimesModal(htmlCopy: string) {
        $('#copyTimesModal')
            .modal({
                onDeny: function () {
                    this.addTimesHTML = '';
                    return true;
                },
                onApprove: () => {
                    this.clipboardService.copyText(htmlCopy, true);
                    this.addTimesHTML = '';

                    this.mixpanelService.trackPlatformEvent(
                        'findtimes',
                        'copy',
                        'outlook',
                        undefined,
                        this.userService.user
                    );
                }
            })
            .modal('show');
    }
}
